import gql from 'graphql-tag';
import {
  checklistStepFragment,
  patientInfoFragment,
  demographicTypesFragment,
  visitDetailFragment,
  encounterInfoFragment
} from './fragments';

export const GetPreRegistrationInfo = gql`
  query GetPreRegistrationInfo($eventId: ID!) {
    preRegistration(eventId: $eventId) {
      complete
      cancelled
      patientInfo {
        ${patientInfoFragment}
      }
      encounterInfo {
        ${encounterInfoFragment}
      }
      guarantorInfo {
        id
        firstName
        lastName
        relationship
        gender
        dateOfBirth
        financialClass
      }
      visitDetail {
        ${visitDetailFragment}
      }
      checkList {
        ${checklistStepFragment}
      }
      demographicTypes {
        ${demographicTypesFragment}
      }
    }
  }
`;
